export default function SolarCell({ plotdata, cell_color, blink_cmd, onClick }) {
    const CellArray = (plotdata, cellcolor, blink_cmd) => {
        const value = plotdata?.row;
        if (value === undefined || value === null) {
            return [];
        }

        let tmp = []
        for (let i = 0; i < plotdata.row?.length; i++) {
            if (plotdata.row?.[i]?.total > 0) {
                let tmp1 = []
                const pv_tag = "pv_" + plotdata.row?.[i]?.pv + "_p"
                const pv_display = "PV" + plotdata.row?.[i]?.pv + " Power"

                for (let k = 0; k < plotdata.row?.[i]?.total; k++) {
                    const Prouted = "INV-" + String(plotdata.row?.[i]?.inv).padStart(2, '0') + ", PV-" + String(plotdata.row?.[i]?.pv).padStart(2, '0')
                    let someStyle = {
                        width: plotdata.width + 'px',
                        height: plotdata.height + 'px',
                    }
                    let cls_offset = ''
                    if (plotdata.row?.[i]?.margin_cell > 0) {
                        cls_offset = 'h-offset'
                    }
                    if (k > 0) {
                        if (plotdata.orient === "vertical") {
                            someStyle.marginTop = plotdata.row?.[i]?.margin_cell + 'px'
                        } else {
                            someStyle.marginLeft = plotdata.row?.[i]?.margin_cell + 'px'
                        }
                    }
                    tmp1.push(<div className={'solar-cell ' + cls_offset} key={i + "-" + k} title={'Routes : ' + Prouted}
                        style={someStyle}
                    ></div>)
                }
                let stly_g
                if (plotdata.orient === "vertical") {
                    stly_g = {
                        marginTop: plotdata.row?.[i]?.margin_group + 'px',
                    }
                } else {
                    stly_g = {
                        marginLeft: plotdata.row?.[i]?.margin_group + 'px',
                    }
                }

                let blink_test = ''
                if (blink_cmd.inv === plotdata.row?.[i]?.inv && blink_cmd.pv === plotdata.row?.[i]?.pv) {
                    blink_test = 'alarmevent-blink-bg-orange'
                }

                if (tmp1.length > 0) {
                    const tx = <div key={i} style={stly_g} className={"solar-group " + plotdata.orient + ' ' + getCellColor(cellcolor, i) + ' ' + blink_test}
                        onClick={() => { onClick("INV-" + String(plotdata.row?.[i]?.inv).padStart(2, '0'), pv_tag, pv_display, plotdata.row?.[i]?.pv, plotdata.row?.[i]?.row_key, plotdata.row?.[i]?.inv) }}
                    >{tmp1}</div>
                    tmp.push(tx)
                }
            }
        }
        return tmp
    }

    const getCellColor = (data, index) => {
        const value = data?.[index];
        if (value === undefined || value === null) {
            return "solar-color-bg-greyx"
        }
        if (data.length > 0) {
            return data[index]
        }
        return "solar-color-bg-greyx"
    }

    return (
        plotdata?.row !== undefined ?
            <div className={"solar-cell-column " + plotdata?.orient} style={{ left: plotdata?.x + "px", top: plotdata?.y + "px" }}>
                {CellArray(plotdata, cell_color, blink_cmd)}
            </div>
            :
            null
    )
}
